export const SET_PROFILE = '@user/SET_PROFILE';
export const DELETE_PROFILE = '@user/DELETE_PROFILE';
export const HIDE_LOGIN_SUCCESS_MODAL = '@user/HIDE_LOGIN_SUCCESS_MODAL';
export const SHOW_LOGIN_SUCCESS_MODAL = '@user/SHOW_LOGIN_SUCCESS_MODAL';

const initialState = {
    profile: null,
    showLoginSuccessModal: false
};

export function user(state = initialState, action) {
    switch (action.type) {
        case SET_PROFILE:
            return {
                ...state,
                profile: action.profile,
            };
        case DELETE_PROFILE:
            return {
                ...state,
                profile: null,
                showLoginSuccessModal: false
            };
        case SHOW_LOGIN_SUCCESS_MODAL:
            return {
                ...state,
                showLoginSuccessModal: true
            };
        case HIDE_LOGIN_SUCCESS_MODAL:
            return {
                ...state,
                showLoginSuccessModal: false
            };
        default:
            return state;
    }
}
